// extracted by mini-css-extract-plugin
module.exports = {"container":"LoadingDashboardButton_container__MrLh5"};